import React, { useState } from "react";
import TitoloColore from "../../commons/TitoloColore";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import SpaceL from "../../commons/SpaceL";
import Space from "../../commons/Space";

function Safeguarding() {
    const [showForm, setShowForm] = useState(false);
    const today = new Date().toLocaleDateString("it-IT");
    const [consensoGdpr, setConsensoGdpr] = useState("");
    const [mogChecked, setMogChecked] = useState(false);
    const [trasmissioneChecked, setTrasmissioneChecked] = useState(false);
    const canSubmit = consensoGdpr === "si" && mogChecked && trasmissioneChecked;
    const [successMessage, setSuccessMessage] = useState(false);

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (consensoGdpr === "no") {
            alert("Non è possibile inviare la segnalazione senza il consenso al trattamento dei dati personali.");
            return;
        }

        const formData = new FormData(e.target);

        try {
            const response = await fetch("/formmail.php", {
                method: "POST",
                body: formData
            });

            if (response.ok) {
                setSuccessMessage(true);  // Mostra il messaggio
                e.target.reset();         // Pulisce il form
                setShowForm(false);       // Chiude il form
            }
            else {
                alert("Si è verificato un errore durante l'invio della email.");
            }
        } catch (error) {
            alert("Errore di rete. Riprova più tardi.");
        }
    };




    return (
        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Safeguarding"} backgroundColor={"#003F83"} />

            <div style={{ padding: "1em" }}>
                <figure className="text-center" style={{ padding: "3em" }}>
                    <blockquote className="blockquote">
                        <p>
                            <strong>IL CIGNO SOCIETA’ SPORTIVA COOP. DILETTANTISTICA</strong>
                            <br/>
                            <br/> ha sviluppato protocolli per la predisposizione di modelli organizzativi e di controllo dell’attività sportiva
                            <br/> e dei codici di condotta a tutela dei minori e per la prevenzione delle molestie, della violenza di genere
                            <br/> e di ogni altra condizione di discriminazione o per ragioni di etnia, religione, convinzioni personali, disabilità, età o orientamento sessuale.
                            <br/> Per qualsiasi segnalazione, è possibile fare riferimento al Sig. Valentino Giovanni
                            <br/> scrivendo una mail all’indirizzo safeguarding@ilcignosport.it o tramite il link “SEGNALAZIONE”.

                            <SpaceL />


                            <div className="text-center">
                                <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/Safeguarding/MOG.pdf" download>MODELLO ORGANIZZATIVO DI GESTIONE E CONTROLLO (MOG)</a>

                                <br />
                                <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/Safeguarding/CdC.pdf" download>CODICE DI CONDOTTA</a>

                                <br/>
                                <button
                                    type="button"
                                    onClick={() => setShowForm(!showForm)}
                                    style={{
                                        ...linkStyle,
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: 0,
                                        textDecoration: "underline",
                                        fontSize: "22px"
                                    }}
                                >
                                    SEGNALAZIONE
                                </button>


                                <SpaceL />
                            </div>
                        </p>
                    </blockquote>
                </figure>

                {showForm && (
                    <div className="d-flex justify-content-center">
                        <form
                            className="mx-auto"
                            style={{ width: "40em" }}
                            action="/formmail.php"
                            method="post"
                            onSubmit={handleSubmit}
                        >
                            {/* Campo nascosto destinatario Aruba */}
                            <input type="hidden" name="recipient" value="sometext" />


                            {/* Data automatica */}
                            <fieldset disabled>
                                <div className="mb-3">
                                    <label className="form-label">Data</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="data_invio"
                                        value={today}
                                        readOnly
                                    />
                                </div>
                            </fieldset>

                            <h6 className="mt-4">1. Informazioni del Segnalante</h6>
                            <input type="text" name="nome_segnalante" className="form-control mb-2" placeholder="Nome e Cognome" />
                            <input type="text" name="ruolo_segnalante" className="form-control mb-2" placeholder="Ruolo nella società" />
                            <input type="text" name="telefono_segnalante" className="form-control mb-2" placeholder="Telefono" />
                            <input
                                type="email"
                                name="email"
                                className="form-control mb-2"
                                placeholder="Email"
                            />


                            <h6 className="mt-4">2. Informazioni della Persona Interessata (se diversa)</h6>
                            <input type="text" name="nome_interessato" className="form-control mb-2" placeholder="Nome e Cognome" />
                            <input type="text" name="eta_interessato" className="form-control mb-2" placeholder="Età" />
                            <input type="text" name="ruolo_interessato" className="form-control mb-2" placeholder="Ruolo nella società" />

                            <h6 className="mt-4">3. Dettagli dell'Evento</h6>
                            <input type="text" name="data_evento" className="form-control mb-2" placeholder="Data dell'evento" />
                            <input type="text" name="ora_evento" className="form-control mb-2" placeholder="Ora dell'evento" />
                            <input type="text" name="luogo_evento" className="form-control mb-2" placeholder="Luogo dell'evento" />
                            <textarea name="descrizione_evento" className="form-control mb-3" rows={4} placeholder="Descrizione dettagliata dell'evento" />

                            <h6 className="mt-4">4. Tipo di Segnalazione</h6>
                            {["Abuso fisico", "Abuso psicologico", "Abuso sessuale", "Violenza", "Discriminazione", "Altro"].map((label) => (
                                <div className="form-check" key={label}>
                                    <input type="checkbox" name="tipo_segnalazione[]" className="form-check-input" value={label} />
                                    <label className="form-check-label">{label}</label>
                                </div>
                            ))}

                            <h6 className="mt-4">5. Testimoni dell'Evento</h6>
                            <input type="text" name="nome_testimone" className="form-control mb-2" placeholder="Nome e Cognome" />
                            <input type="text" name="contatto_testimone" className="form-control mb-2" placeholder="Contatto" />

                            <h6 className="mt-4">6. Eventuali Azioni Già Intraprese</h6>
                            <div className="form-check">
                                <input type="radio" name="azioni_gia_intraprese" className="form-check-input" value="si" />
                                <label className="form-check-label">Sì</label>
                            </div>
                            <div className="form-check mb-2">
                                <input type="radio" name="azioni_gia_intraprese" className="form-check-input" value="no" />
                                <label className="form-check-label">No</label>
                            </div>
                            <input type="text" name="a_chi" className="form-control mb-2" placeholder="Se sì, a chi" />
                            <textarea name="azioni_intraprese" className="form-control mb-3" rows={3} placeholder="Azioni intraprese" />

                            <h6 className="mt-4">7. Altre Informazioni Utili</h6>
                            <textarea name="altre_info" className="form-control mb-3" rows={3} />

                            <h6 className="mt-4">8. Dichiarazioni e Consenso alla Gestione dei Dati Personali</h6>
                            <p className="small">
                                Consapevole della veridicità della segnalazione e degli effetti in caso di eventuale falsa dichiarazione:
                            </p>

                            {/* GDPR */}
                            <div className="mb-3">
                                <p className="small mb-1">
                                    Acconsento al trattamento dei miei dati personali e di quelli della persona interessata (GDPR)
                                </p>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        name="consenso_gdpr"
                                        className="form-check-input"
                                        value="si"
                                        onChange={(e) => setConsensoGdpr(e.target.value)}
                                    />
                                    <label className="form-check-label">Sì</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        type="radio"
                                        name="consenso_gdpr"
                                        className="form-check-input"
                                        value="no"
                                        onChange={(e) => setConsensoGdpr(e.target.value)}
                                    />
                                    <label className="form-check-label">No</label>
                                </div>

                                {consensoGdpr === "no" && (
                                    <div className="alert alert-danger mt-2">
                                        Non è possibile inviare la segnalazione senza il consenso al trattamento dei dati personali.
                                    </div>
                                )}
                            </div>

                            {/* MOG */}
                            <div className="form-check mb-3">
                                <input
                                    type="checkbox"
                                    name="presa_visione_mog"
                                    className="form-check-input"
                                    checked={mogChecked}
                                    onChange={(e) => setMogChecked(e.target.checked)}
                                />
                                <label className="form-check-label">
                                    Dichiaro di avere preso visione ed accettato il Modello Organizzativo di Gestione dell’attività sportiva (MOG) e il Codice di Condotta.
                                </label>
                            </div>

                            {/* Trasmissione */}
                            <div className="form-check mb-4">
                                <input
                                    type="checkbox"
                                    name="consenso_trasmissione"
                                    className="form-check-input"
                                    checked={trasmissioneChecked}
                                    onChange={(e) => setTrasmissioneChecked(e.target.checked)}
                                />
                                <label className="form-check-label">
                                    Acconsento alla trasmissione della segnalazione al Responsabile Safeguarding e alle Autorità competenti.
                                </label>
                            </div>

                            <button type="submit" className="btn btn-primary w-100" disabled={!canSubmit}>
                                Invia Segnalazione
                            </button>

                            {successMessage && (
                                <div className="alert alert-success mt-3">
                                    Email inviata correttamente!
                                </div>
                            )}


                        </form>
                    </div>
                )}

                <Space />

            </div>
        </div>
    );
}

const linkStyle = {
    fontSize: "20px",
    padding: "1em",
    fontFamily: "Hammersmith One",
    color: "#032041"
};


export default Safeguarding;
